<template>
  <BBreadcrumb
    class="breadcrumb-slash mx-2 flex-nowrap overflow-hidden"
    style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 10px 5px;"
  >
    <BBreadcrumbItem
      @click="emitGoTo(null)"
    >
      Home
    </BBreadcrumbItem>
    <BBreadcrumbItem
      v-for="item in breadcrumb"
      :key="item.id"
      :active="item.id === currentFolder"
      :class="classItem"
      @click="emitGoTo(item.id)"
    >
      <span v-if="breadcrumb.length > 6">
        {{ item.label | truncate(15,'...') }}
      </span>
      <span v-else>
        {{ item.label }}
      </span>
    </BBreadcrumbItem>
  </BBreadcrumb>
</template>
<script>
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

export default {
  name: 'FilesBreadcrumb',
  components: {
    BBreadcrumb, BBreadcrumbItem,
  },
  props: {
    breadcrumb: {},
    classItem: {},
    currentFolder: {},
    goTo: {},
  },
  created() {

  },
  methods: {
    emitGoTo(id) {
      this.$emit('go-to', id)
    },

  },
}
</script>
